import { useEffect, useState } from "react";

export default function CodexsanBadge() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1400);
    return () => clearTimeout(t);
  }, []);

  return (
    <a
      href="#"
      data-testid="codexsan-badge"
      aria-label="Geliştiren: CodexsanAPP Yazılım Firması"
      className={`fixed z-40 bottom-6 left-6 transition-all duration-700 ${
        visible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      onClick={(e) => e.preventDefault()}
    >
      <span className="group flex items-center gap-2.5 pl-2 pr-4 py-1.5 rounded-full bg-black/80 backdrop-blur-xl border border-white/10 hover:border-[#4f7cff]/60 hover:bg-black/90 transition-all shadow-[0_8px_28px_-8px_rgba(0,0,0,0.6)]">
        <span className="relative flex items-center justify-center w-8 h-8 rounded-full bg-white/95 overflow-hidden">
          <img
            src="https://customer-assets.emergentagent.com/job_inci-aku-bayi-demo/artifacts/tymc1ivu_CodexsanAPP%20Logo.png"
            alt="CodexsanAPP"
            className="w-7 h-7 object-contain"
            loading="lazy"
          />
        </span>
        <span className="leading-tight">
          <span className="block text-[9px] uppercase tracking-[0.2em] text-white/55 font-medium">
            Geliştiren
          </span>
          <span
            className="block text-xs font-bold tracking-tight"
            style={{
              background:
                "linear-gradient(90deg, #4f7cff 0%, #7a4fff 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            CodexsanAPP
          </span>
        </span>
      </span>
    </a>
  );
}
